import { selector, useRecoilValue } from 'recoil';
import _ from 'lodash';
import { authState, currentUser, impersonateAccount } from 'state';
import { AccountInfo, User } from 'types';

export type UserInfo = {
    accountId: string,
    accounts: AccountInfo[],
} & User;

export const realUserInfo = selector<UserInfo>({
    key: 'realUserInfo',
    get: ({ get }) => {
        const auth = get(authState);
        const userData = get(currentUser);
        const user = {
            ...((_.get(auth, 'user') || {}) as UserInfo),
            ...userData,
        }
        return user;
    }
});

export const impersonateInfo = selector<UserInfo | undefined>({
    key: 'impersonateInfo',
    get: ({ get }) => {
        const account = get(impersonateAccount);
        const user = get(realUserInfo);
        if (account && user.isInternalUser) {
            return {
                fullName: account.accountName,
                firstName: account.accountName,
                lastName: '',
                emailAddress: '',
                isInternalUser: false,
                isFinalApprover: false,
                accountId: account.accountId,
                accounts: [account],
                disputeQueueId: 0
            };
        }
        return undefined;
    }
});

export const userInfo = selector<UserInfo>({
    key: 'userInfo',
    get: ({ get }) => {
        const user = get(realUserInfo);
        const impersonate = get(impersonateInfo);

        return impersonate 
        ?? {
            ...user
        };
    }
});

export const useImpersonateInfo = () => useRecoilValue(impersonateInfo);
export const useRealUserInfo = () => useRecoilValue(realUserInfo);
export const useUserInfo = () => useRecoilValue(userInfo);